import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateQuote } from "../QuoteService";
import { showToast } from "../../../../common/Toaster/Toaster";

const useUpdateQuote = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateQuote,
    onSuccess: (_data, variables) => {
      showToast("Quote updated successfully", "success");
      // Reload with getQuote so the Quotes tab shows the saved attributes
      queryClient.invalidateQueries({
        queryKey: ["quote", "details", String(variables.entityid)],
      });
    },
    onError: (error) => {
      showToast(
        error?.response?.data?.error_message || "Error while updating quote",
        "error"
      );
    },
  });
};

export default useUpdateQuote;
